import React, {useEffect, useState} from 'react';
import {withTranslation} from "react-i18next";
import Layout from "../../layout/Layout";
import {useParams} from "react-router-dom";
import {format_date, getData} from "../../helpers/utils";

const PortfolioDetail = ({t}) => {

    const [detail, setDetail] = useState({})
    const r = useParams()

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        const data  = await getData()
        setDetail(data?.portfolio.filter(port  => port.slug === r.key)[0])
    }




    return (
        <Layout pageName={detail?.name}>

        </Layout>
    )
}

export default withTranslation()(PortfolioDetail)